import { RES_DOMAIN } from "constant/config";
import {
    ADULT,
    ADULT_LOCK,
    AUTH_DENIED,
    BLIND,
    DELETE,
    ENCODING_FAIL,
    EXPIRE,
    LOADING,
    LOCK,
    SUCCEED,
    UPLOAD_FAIL,
} from "constant/ucc.thumb.type";
import React, { useState, useMemo } from "react";
import { Trans } from "react-i18next";
import { CATCH, CATCHSTORY } from "constant/filetype";
import { isNonBlur } from "helpers";
import classNames from "classnames";

const CatchImage = ({ vod, page }) => {
    const { thumb = "", thumb_type: thumbType = SUCCEED } = vod;
    const [imgError, setImgError] = useState(false);

    const handleVodImageError = (e) => {
        setImgError(true);
    };

    const thumbnail = useMemo(() => {

        // 캐치 영역
        // PC 홈(세로형 - 블러 있음) : page값 main
        // MO 홈(세로형 - 블러 있음) : page값 main
        // PC VOD 피드형(가로형 블러 없음) - 얘는 이 컴포넌트 안탐, VodImage 컴포넌트 탐
        // PC VOD 그리드형(가로형 블러 있음) : page값 pc_vod
        // MO VOD(세로형 블러 있음) : page값 vod
        if(vod.file_type===CATCH && vod.catchInfo !== null){    // 운영자가 삭제한 캐치의 경우 catchInfo가 null로 들어오는 케이스 방지
            // PC 홈, MO 홈 가로형 캐치 블러 처리
            if(page === "main" && vod.catchInfo?.resolution_type === 'horizontal') {
                // 가로형 캐치의 세로 이미지
                return (
                    <span className="thumb">
                        <img src={thumb} alt="" onError={handleVodImageError} loading="lazy"/>
                        <div className="thumb_blur" style={{ backgroundImage: `url(${thumb})`}}></div>
                    </span>
                );
            }
            else {
                // MO VOD 가로형 썸네일, PC VOD 그리드형
                if(vod.catchInfo?.resolution_type == "horizontal"){
                    return (
                        <span className="thum thumb_16_9">
                            <img src={vod.thumb} alt="" onError={handleVodImageError} loading="lazy"/>
                            <div className={classNames("thumb_blur", isNonBlur() ? "blur_remove" : "")}>
                                <img src={vod?.thumb} alt=""/>
                            </div>
                        </span>
                    );
                // MO vod 세로형 썸네일, PC홈, MO홈 세로형 썸네일, PC VOD 그리드형
                } else {
                    return (
                        <span className={classNames(page === "pc_vod" ? "thum" : "thumb")}>
                            <img src={vod.catchInfo?.thumb} alt="" onError={handleVodImageError} loading="lazy"/>
                        </span>
                    );
                }
            }
        }

        // 캐치스토리
        if(vod.file_type=== CATCHSTORY ){
            if(vod.resolution_type === 'horizontal'){
                // 가로형
                return (
                    <span className="thum thumb_16_9">
                        <img src={vod.thumb_h} alt="" onError={handleVodImageError} loading="lazy"/>
                        <div className={classNames("thumb_blur", isNonBlur() ? "blur_remove" : "")}>
                            <img src={vod.thumb_h} alt="" loading="lazy"/>
                        </div>
                    </span>
                );
            } else {
                // 세로형
                return (
                    <span className="thum">
                        <img src={vod.thumb} alt="" onError={handleVodImageError} loading="lazy"/>
                    </span>
                );
            }
        }

        // 위에서 리턴되지 않았다면 imgError 처리
        handleVodImageError();
	}, []);

    switch (thumbType) {
        case ENCODING_FAIL: // 인코딩 실패
            return(
                <span className="thumb-encoding">
                    <em><Trans>인코딩 실패</Trans></em>
                </span>
            );

        case UPLOAD_FAIL: // 업로드 실패
            return(
                <span className="thumb-upload">
                    <em><Trans>업로드 실패</Trans></em>
                </span>
            );
        case DELETE: // 어드민 삭제
            return(
                <span className="thumb-del">
                    <em>숲지기 삭제</em>
                </span>
            );
        case LOADING: // 로딩 중(변환 중)
            return(
                <span className="thumb-converting">
                    <em><Trans>VOD 변환중</Trans></em>
                </span>
            );
        case BLIND: // 블라인드 영상
            return (
                <span className="thumb-blind">
                    <em><Trans>블라인드</Trans></em>
                </span>
            );
        // 권한 없는 게시글
        case AUTH_DENIED:
            return (
                <span className="thum thumb-default">
                    <Trans>썸네일</Trans>
                </span>
            );

        // 기간 만료
        case EXPIRE:
            return <img src={`${RES_DOMAIN}/images/mobile/mybs/img_expire.jpg`} alt="" loading="lazy" />;

        // 19금 비공개
        case ADULT_LOCK:
            return (
                <span className="thumb-lock_adult">
                    <Trans>19금 + 비번방</Trans>
                </span>
            );

        // 비공개
        case LOCK:
            return (
                <span className="thumb-private">
                    비공개
                </span>
            );

        // 성인 영상
        case ADULT:
            return (
                <span className="thumb-adult">
                    <Trans>19금</Trans>
                </span>
            );

        // 완료 - 썸네일 노출
        case SUCCEED:
        default:
            if (imgError) {
                return (
                    <span className="thum thumb-default">
                        <Trans>썸네일</Trans>
                    </span>
                );
            } else { 
                return thumbnail
            }
    }
};

export default CatchImage;
